import { writable } from 'svelte/store';
let localReencodeSetting = Boolean(localStorage.getItem('reencode'));
let initialEncodeSetting = localReencodeSetting;
const { subscribe, update } = writable(initialEncodeSetting);
const actions = {
    update: (reencode) => {
        update(() => reencode);
        localStorage.setItem('reencode', String(reencode));
    }
};
const reencode = {
    subscribe,
    ...actions
};
export default reencode;
